// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.calculation-report-text-production {\r\n  color: #934848;\r\n  font-weight: bold;\n}\n.calculation-report-text-summ {\r\n  color: #4f7ecb;\r\n  font-weight: bold;\n}\n.calculation-report-text-total {\r\n  font-weight: bold;\n}\n.calculation-report-text-focused {\r\n  font-weight: bold !important;\r\n  color: green;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
